import { render, staticRenderFns } from "./MenuSubNode.vue?vue&type=template&id=64813346&"
import script from "./MenuSubNode.vue?vue&type=script&lang=js&"
export * from "./MenuSubNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports